var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[(_vm.profitable === null)?_c('span',[_vm._t("default")],2):(_vm.profitable === true)?_c('span',{staticClass:"text-success"},[_vm._t("default"),_vm._v(" ✅\n  ")],2):(_vm.profitable === false)?_c('span',{staticClass:"text-danger"},[_vm._t("default"),_vm._v(" ❌\n  ")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-325eed96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hit-calculator/five-card-hands-section/insights/header-cell.vue
// module id = 6vFa
// module chunks = 0